import React from 'react';
import { Violator } from '@hpstellar/core';
import { Violator as ViolatorVisId } from '@hpstellar/core/visId';
import { Shipping } from '@hpstellar/vis-icons';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import withPageComponents from '../../../page/components/with-page-components';
import './delivery-message.less';

const isAfterHoliday = (shipDate, targetMonth, targetDay) => {
    //benchmark day is 12/25 of the current year AKA Christmas
    const holidayDate = new Date(new Date().getFullYear(), targetMonth - 1, targetDay);
    return new Date(shipDate) > holidayDate;
};
const formatShipDate = dateStr => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    const month = months[d.getMonth()];
    const day = d.getDate();
    const year = String(d.getFullYear()).slice(-2);
    return `${month} ${day},${year}`;
};

export default withPageComponents(
    ({ shipDate, ctoProductInitial, ctoSettings, textOnly = false, visId = false }) => {
        const { css } = useTemplateTheme();
        const { holidayMessageSettings } = ctoSettings || {};
        const { enableHolildayDeliveryMessage, targetDay, targetMonth, defaultMessage, lateMessage } =
            holidayMessageSettings || {};
        const { isSMB } = ctoProductInitial || {};
        const { date } = shipDate || {};
        const deliveryMessage = date && `Ships on ${date}`;
        const enableHolidayMessage = !isSMB && enableHolildayDeliveryMessage;
        if (!deliveryMessage) {
            return null;
        }
        if (textOnly && !enableHolidayMessage) {
            return deliveryMessage;
        }
        if (enableHolidayMessage) {
            const isLate = isAfterHoliday(date, targetMonth, targetDay);
            return (
                <span className={`delivery-holiday-message${isLate ? ' late-arrival' : ''}`}>
                    {isLate ? lateMessage : defaultMessage}
                </span>
            );
        }

        if (visId) {
            if (!date) {
                return null;
            }
            const formattedDate = formatShipDate(date);
            const message = `Ships on ${formattedDate}`;
            return (
                <ViolatorVisId
                    variant="footnotes"
                    label={message}
                    icon={<Shipping size="s" />}
                    className="configure-shipping_violator_visId"
                />
            );
        }

        return (
            <Violator
                variation="product"
                value={deliveryMessage}
                className={`configure-shipping_violator ${css ? `${css}-product-violator` : ''}`}
            />
        );
    },
    {
        components: ['shipDate', 'ctoProductInitial', 'ctoSettings'],
    },
);
